import { DeliveriesMain } from '@/_features/deliveries';

function Deliveries() {
  return (
    <div className="container">
      <DeliveriesMain />
    </div>
  );
}

export default Deliveries;
